module.exports = __webpack_public_path__ + "assets/img/背景.70b89056.jpg";